<div class="flex justify-between header">
  <h2 color="primary">{{data.title}}</h2>
  <button mat-icon-button mat-dialog-close aria-label="Chiudi" matTooltip="Chiudi">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<mat-dialog-content class="pdf-viewer-dialog">

  <div class="flex flex-row justify-center" style="height: 100%;">
    <div style="width: 80%; height: 100%; background-color: lightgray; padding: 10px;">
      <pdf-viewer [src]="pdfSrc" [render-text]="true" [original-size]="false" style="height: 100%; width: 100%;">
      </pdf-viewer>
    </div>

  </div>


</mat-dialog-content>
